import {
  getCountryCode,
  getCountryName,
  GMapsToWTBAddress,
  Logger
} from 'wtb-utils';

const billingRequiredFields = {
  name: true,
  email: true,
  phone: true,
  address: true
};

const fromFEtoBE = (data, isBilling, requiredFields = billingRequiredFields) => {
  const _customerData = { /* id: customer.id, */ ...data };

  delete _customerData.id;

  if (_customerData.country) {
    _customerData.country = getCountryCode(_customerData.country);
  }

  if (_customerData.phone) {
    _customerData.phone = _customerData.phone.replace(/[- )(]/g, '');
  }

  if (requiredFields.name && _customerData.firstName) {
    _customerData.name = {
      first: _customerData.firstName,
      last: _customerData.lastName
    };
  }
  delete _customerData.firstName;
  delete _customerData.lastName;

  if (!requiredFields.email) delete _customerData.email;
  if (!requiredFields.phone) delete _customerData.phone;

  if (requiredFields.address && _customerData.street) {
    _customerData.address = {
      street: _customerData.street,
      streetAdditional: _customerData.streetAdditional,
      zip: _customerData.zipCode,
      city: _customerData.city,
      country: _customerData.country
    };

    if (_customerData.address.streetAdditional === '') {
      delete _customerData.address.streetAdditional;
    }

    if (typeof _customerData.address.street !== 'string') {
      _customerData.address.street = GMapsToWTBAddress(_customerData.address.street);
    }
  }
  delete _customerData.street;
  delete _customerData.streetAdditional;
  delete _customerData.zipCode;
  delete _customerData.city;
  delete _customerData.country;
  delete _customerData.language;

  if (isBilling) {
    delete _customerData.nationalId;
  }

  return _customerData;
};

const fromBEtoFE = (data = {}, customer = {}) => {
  const _data = { ...data };

  if (_data.name?.first) {
    _data.firstName = _data.name.first;
  }
  if (_data.name?.last) {
    _data.lastName = _data.name.last;
  }
  if (_data.address?.street) {
    _data.street = _data.address.street;
  }
  if (_data.address?.streetAdditional) {
    _data.streetAdditional = _data.address.streetAdditional;
  }
  if (_data.address?.zip) {
    _data.zipCode = _data.address.zip;
  }
  if (_data.address?.city) {
    _data.city = _data.address.city;
  }
  if (_data.address?.country) {
    if (!_data.language) {
      Logger.error('Language needed in order to set the country name');
      return undefined;
    }

    _data.country = getCountryName(_data.address.country, _data.language);

    // Default to English name in case the language isn't supported by any reason
    if (!_data.country) {
      Logger.error(`Getting country name in ${_data.language} didn't work. Defaulting to English.`);
      getCountryName(_data.address.country, 'en');
    }
  }
  if (customer?.nationalId) {
    _data.nationalId = customer.nationalId;
  }

  delete _data.name;
  delete _data.address;
  delete _data.language;

  return _data;
};

export {
  fromFEtoBE,
  fromBEtoFE
};
